import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarehousePageWrapper } from '../../ui-kit';
import { routePaths } from '../../routePaths';
import { WarehousePermission } from '../../generated/graphql';
import { WarehouseCategoriesList } from './components/WarehouseCategories';

const WarehouseCategoriesPage = () => {
    const { t } = useTranslation();
    const addNewCategoryString = t('New category');

    const warehouseCategoriesActions = [
        {
            route: routePaths.warehouseCategories,
            text: addNewCategoryString,
        },
    ];

    return (
        <WarehousePageWrapper
            permissions={{ warehouse: [WarehousePermission.CanAddStockCardCategory] }}
            actions={warehouseCategoriesActions}
        >
            <WarehouseCategoriesList />
        </WarehousePageWrapper>
    );
};

export default WarehouseCategoriesPage;
